import cn from 'classnames';
import css from './SeatMapSeat.css';
export function getSeatColor(rfisc) {
    return cn({
        [css.yellow]: rfisc === 'CMF',
        [css.bone]: rfisc === '0B5',
        [css.soap]: rfisc === 'Y42',
        [css.green]: rfisc === 'STX',
        [css.coral]: rfisc === 'STA',
        [css.jellyfish]: rfisc === 'TB5',
        [css.lavender]: rfisc === 'STR',
        [css.cyan]: rfisc === 'SPC'
    });
}
